module.exports = __webpack_public_path__ + "img/list-pic.e7b2a1d6.png";